import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'deadlineTime'
})
export class DeadlineTimePipe implements PipeTransform {
  transform(startDate: Date, endDate: Date): string {
    if (!startDate && !endDate) {
      return '--';
    }

    const today = new Date();
    if (startDate > today) {
      return `Starts in ${this.dateDifference(startDate, today)}`;
    } else if (startDate <= today && today <= endDate) {
      return `In ${this.dateDifference(today, endDate)}`;
    } else {
      return `${this.dateDifference(today, endDate)} ago`;
    }
  }

  private dateDifference(startDate: Date, endDate: Date): string {
    const firstDateInMs = startDate.getTime();
    const secondDateInMs = endDate.getTime();

    const differenceBtwDates = secondDateInMs - firstDateInMs;

    const aDayInMs = 24 * 60 * 60 * 1000;

    const days = this.setPositive(Math.round(differenceBtwDates / aDayInMs));
    if (days !== 0) {
      return `${days} day${days > 1 ? 's' : ''}`;
    } else {
      const seconds = Math.round((differenceBtwDates / 1000) % 60);
      const minutes = this.setPositive(Math.round((differenceBtwDates / (1000 * 60)) % 60));
      const hours = this.setPositive(Math.round((differenceBtwDates / (1000 * 60 * 60)) % 24));

      if (hours !== 0) {
        return `${hours} hour${hours > 1 ? 's' : ''}`;
      } else if (minutes !== 0) {
        return `${minutes} minute${minutes > 1 ? 's' : ''}`;
      } else {
        if (seconds < 0) {
          return 'a few seconds';
        } else {
          return 'few seconds';
        }
      }
    }
  }

  private setPositive(num: number): number {
    return num < 0 ? num * -1 : num;
  }
}
